import React, { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import ImportExcelModal from "./ImportExcelModal";
import {
    deleteNonVerifiedUserData,
    getAdminCategoryType
} from "../../../services/adminApiService/adminCategoryType/AdminCategoryTypeApi";
import {
    deleteInsitutionNonVerifiedUserData,
    getDwnLoadOrganisationList,
    getOrganisationList
} from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import { useParams } from "react-router-dom";
import { useFilterReset } from "../../../hooks/useFilterReset";
import { formatStatus, getStatusColor } from "../../../utils/colorAsperStatus";
import ReactPaginate from "react-paginate";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import FilterNumber from "../../../jsx/components/FilterNumberDropDown/FilterNumber";
import SearchFilter from "../../../jsx/components/SearchFilter/SearchFilter";
import useSearchValue from "../../../hooks/useSearchValue";
import { LocationContext } from "../../../context/LocationContext";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";
import { useSport } from "../../../context/SportContext";
import SportFilter from "../sportFilter/SportFilter";
import DistrictFilter from "../districtFilter/DistrictFilter";
import CategorySubCategoryFilter from "../categorySubCateogoryFilter/CategorySubCategoryFilter";
import RefreshButton from "../../../jsx/components/RefreshButton/RefreshButton";
import { organisationExcelHeaders } from "./InsitutionExcelHeader";
import DownloadExcelButton from "../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton";
import swal from "sweetalert";
import notify from "../../../utils/notification";
import { AuthContext } from "../../../context/AuthContext";
import { isUserSuperAdmin, isUserAdminChecker, isCompletedStatus } from "../../../utils/userRoleUtils";
const OrganizationList = () => {
  const { user, USER_LEVEL } = useContext(AuthContext);
  const isSuperAdmin = isUserSuperAdmin(user);
  const isAdminChecker = isUserAdminChecker(user);
  const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showImportModal, setShowImportModal] = useState(false);
  const [adminCategoryTypeData, setAdminCategoryTypeData] = useState([]);
  const [organisationdataList, setOrganisationdataList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
  const [selectedCategory, setSelectedCategory] = useState('');
  const { selectedSportId, setSelectedSportId } = useSport();
  const navigate = useNavigate();
  const handleVerificationClick = (id) => {
    localStorage.removeItem("verify_doc_remarks");
    navigate(`/verification-form/${id}`); // Absolute path
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setCurrentPage(1);
  };

  // const filteredData = selectedStatus
  //   ? organisationdataList.data.filter((data) => data.status === selectedStatus)
  //   : organisationdataList.data;


  const getOrganisationListApi = async (perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, selectedSportId) => {

    setLoading(true);
    try {
      // Sub-category filter removed for Institution List as per Govt requirement Point 12
      const response = await getOrganisationList(perPage, currentPage, selectedStatus, searchValue, selectedDistrictId, selectedCategory, "", selectedSportId);
      setOrganisationdataList(response?.data?.data);
    } catch (error) {
      console.error("Login error:", error);
    } finally {

      setLoading(false);
    }
  };

  const getAdminCategoryTypeListApi = async () => {
    try {
      const response = await getAdminCategoryType(2);
      // console.log("responseCategoryTYpe", response);
      setAdminCategoryTypeData(response?.data);
    } catch (error) {
      console.error("Login error:", error);
    }
  };
  useEffect(() => {
    setCurrentPage(1);
    setPerPage(10);
    setSelectedStatus(0);
    setDebouncedSearchValue("");
    setSelectedDistrictId("");
    setSelectedCategory("");
    setSelectedSportId("");
  }, []);
  useEffect(() => {
    getAdminCategoryTypeListApi();
  }, []);

  useEffect(() => {
    getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSportId);
  }, [currentPage, perPage, selectedStatus, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSportId]);

  const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


    // const handleDeleteClick  = async(id) => {
    //     try {
    //         const payload = {
    //             id : id
    //         }
    //         const response  = await deleteInsitutionNonVerifiedUserData(payload);
    //         if (response?.data?.status === true) {
    //             swal(`${response?.data?.message}`);
    //             getOrganisationListApi(perPage, currentPage, selectedStatus, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId);
    //         } else {
    //             notify('error', response.data.message);
    //         }
    //
    //     }catch(error){
    //         console.log("error",error);
    //     }
    // };

    const handleDeleteClick = async (id) => {
        const confirm = await swal({
            title: "Are you sure you want to delete this user profile?",
            text: "This action cannot be undone, and all associated data will be permanently removed.",
            icon: "warning",
            buttons: ["Cancel", "Yes, Delete"],
            dangerMode: true,
        });

        if (!confirm) return; // ❌ Stop if user cancels

        try {
            const payload = { id };

            const response = await deleteInsitutionNonVerifiedUserData(payload);

            if (response?.data?.status === true) {
                swal("Deleted!", response?.data?.message, "success");

                getOrganisationListApi(
                    perPage,
                    currentPage,
                    selectedStatus,
                    debouncedSearchValue,
                    selectedDistrictId,
                    selectedCategory,
                    selectedSportId
                );
            } else {
                notify("error", response?.data?.message);
            }
        } catch (error) {
            console.log("error", error);
            notify("error", "Something went wrong. Please try again.");
        }
    };

    const handleRefresh = useFilterReset({
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedStatus,
    setSelectedDistrictId,
    setSelectedCategory,
    setPerPage,
    setCurrentPage,
    setSelectedSportId,
    fetchFunction: (p, c, s, search, dist, _subCat, sport) => {
      getOrganisationListApi(p, c, s, search, dist, "", sport);
    },

  });

  return (
    <>
      <PageTitle
        activeMenu="Institution List"
        motherMenu="Manage Registration"
      />
      <div className="col-12">
        <div className="card">
          <div className="px-2">
            <div className="d-flex justify-content-between">
              <div className="d-flex mt-3 px-4 mb-3">
                <div>
                  <FilterNumber value={perPage} onChange={setPerPage} />
                </div>

                <div>
                  <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} />
                </div>

              </div>

              <div className="d-flex mt-3">


                <div className="">
                  <DownloadExcelButton
                    // data={organisationdataList}
                    data={
                      (organisationdataList?.data || organisationdataList || []).map((item, index) => ({
                        serial: index + 1, // ✅ add serial number
                        ...item,
                      }))
                    }
                    // headers={organisationExcelHeaders}
                    headers={[
                      { label: "Sr.No", key: "serial" }, // ✅ add serial header
                      ...organisationExcelHeaders,
                    ]}
                    btnName="Download Excel"
                    fileName="InsitutionList.xlsx"
                  />
                </div>
                <div className="mx-2">
                  <DownloadExcelButton
                    headers={[
                      { label: "S.No", key: "serial" }, // Add Serial Number column
                      ...organisationExcelHeaders
                    ]}
                    btnName="Download All Data"
                    fileName="AllInsitutionList.xlsx"
                    onClick={async () => {
                      const response = await getDwnLoadOrganisationList();
                      const allData = response?.data?.data || [];
                      const withSerial = allData.map((item, index) => ({
                        serial: index + 1,  // matches header key
                        ...item
                      }));

                      return withSerial;
                    }}
                  />
                </div>


                <div>
                  <Button
                    variant="primary"
                    className=""
                    onClick={() => setShowImportModal(true)}
                  >
                    Import Excel <i className="fa fa-plus"></i>
                  </Button>
                </div>
                <div>
                  <RefreshButton refreshCallback={handleRefresh} />
                </div>


              </div>
            </div>
                        <div className="d-flex px-3">
              <div className="mx-2">
                <SportFilter />
              </div>
              <div>
                <Form.Select
                  value={selectedStatus}
                  onChange={handleStatusChange}
                  className="me-2"
                  style={{ width: "160px", padding: "11px" }}
                >
                  <option value="0">All Status</option>
                  <option value="reject">Reject</option>
                  <option value="pass">Pass</option>
                  <option value="final_submit">Final Submit</option>
                  <option value="initial">Initial</option>
                  <option value="ask_for_resubmit">Ask for Resubmit</option>
                  <option value="pass_by_dso">Pass by DSO</option>
                  <option value="pass_by_admin_checker">Pass by Admin Checker</option>
                </Form.Select>
              </div>
              <div className="mx-2">
                <DistrictFilter />
              </div>
              <div>
                <CategorySubCategoryFilter typeId="2"
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  placeholderText="Institution"
                  hideSubCategory={true}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>

          </div>
          <div className="card-body">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="w-100 table-responsive">
                <div id="example_wrapper" className="dataTables_wrapper">
                  <form>
                    <table id="example" className="display w-100 dataTable">
                      <thead>
                        <tr>
                          <th>SN</th>
                          {/* <th>Legal Entity</th> */}
                          <th>Reg. No</th>
                          <th>Prov.Reg.Id</th>
                          <th>Name of Institution</th>
                          <th>Institution Email</th>
                          <th>Attempt</th>
                          {/* <th>Contact Person Email</th> */}
                          <th>Contact Person Mobile</th>
                          <th>Date of Submission</th>
                          <th>Remarks</th>
                          <th> Institution Password</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {organisationdataList?.data?.length > 0 ? (
                          (organisationdataList?.data || []).map((data, index) => (
                          <tr key={data?.id || index}>
                            <td>{index + 1 + (currentPage - 1) * perPage}</td>
                            <td>{data?.registration_number}</td>
                            <td>{data?.provisinal_registration_id}</td>
                            <td>{data?.name_of_organization}</td>
                            <td>{data?.email}</td>
                            <td>{data?.attempt_count + 1}</td>
                            <td>{data?.contact_person_contact}</td>
                            <td>{formatDateTime(data?.submitted_at || data?.date_of_submission || data?.created_at)}</td>
                            <td>{data?.remarks || data?.remark || "-"}</td>
                            <td>{data?.org_pwd}</td>
                            <td style={{ color: getStatusColor(data?.status) }}>
                              {data?.status && formatStatus(data?.status)}
                            </td>
                            <td>
                              <div className="d-flex">
                                <div>
                                  <Button
                                    variant="danger"
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() => handleDeleteClick(data?.id)}
                                    disabled={data?.status === "pass"}
                                  >
                                    Delete
                                  </Button>
                                </div>
                                <div className="mx-2">
                                  <Button
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() => handleVerificationClick(data?.id)}
                                    disabled={data?.status === "initial" || data?.status === "pass"}
                                  >
                                    Verify Application
                                  </Button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center">
                              Data is not available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ImportExcelModal
        showImportModal={showImportModal}
        setShowImportModal={setShowImportModal}
        adminCategoryTypeData={adminCategoryTypeData}
        getOrganisationListApi={getOrganisationListApi}
        currentPage={currentPage}
        perPage={perPage}
        selectedStatus={selectedStatus}
        setCurrentPage={setCurrentPage}
        selectedSportsId={selectedSportId}
        insitutionType="Insitution"
        typeValue="2"
      />

      <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={8}
        marginPagesDisplayed={5}
        pageCount={Math.ceil(organisationdataList?.total / perPage)}
        previousLabel="< previous"
        pageClassName="page-item mx-1 my-1"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link mx-1 my-1"
        nextClassName="page-item mx-1 my-1"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item mx-1 my-1"
        breakLinkClassName="page-link"
        containerClassName="pagination d-flex flex-wrap"
        activeClassName="active"
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </>
  );
};

export default OrganizationList;
